"use client";

import { useState } from "react";
import { klaviyoSubscribe } from "@/lib/klaviyo";

// Newsletter sign-up straight into Klaviyo's subscribers list (replaces the live site's popup).
// Submitting the form is the opt-in, and the consent wording says so. It only says "you're on the
// list" once Klaviyo has accepted the sign-up; otherwise it shows an error and keeps the details.
export default function KlaviyoSignup({ source = "Sign-up band", compact = false }) {
  const [state, setState] = useState("idle");

  const onSubmit = async (e) => {
    e.preventDefault();
    const f = e.currentTarget;
    if (f.elements.namedItem("website")?.value) return; // honeypot
    setState("sending");
    const ok = await klaviyoSubscribe({ email: f.elements.namedItem("email").value, name: f.elements.namedItem("name").value, source });
    if (ok) {
      setState("done");
      f.reset();
    } else {
      setState("error");
    }
  };

  if (state === "done") {
    return <p className="kl-signup__done" role="status">You&rsquo;re on the list. Look out for Lulu&rsquo;s next email.</p>;
  }
  return (
    <form className={`kl-signup ${compact ? "kl-signup--compact" : ""}`} onSubmit={onSubmit}>
      <input type="text" name="website" tabIndex={-1} autoComplete="off" aria-hidden="true" className="wform-botcheck" />
      <label>
        <span className="sr-only">First name</span>
        <input type="text" name="name" placeholder="First name" autoComplete="given-name" />
      </label>
      <label>
        <span className="sr-only">Email address</span>
        <input type="email" name="email" placeholder="Email address" autoComplete="email" required />
      </label>
      <button type="submit" className="btn btn--solid" disabled={state === "sending"}>
        {state === "sending" ? "Signing up…" : "Sign up"}
      </button>
      {state === "error" && (
        <p className="kl-signup__error" role="alert">
          That didn&rsquo;t go through. Please check your email address and try again.
        </p>
      )}
      <p className="kl-signup__small">
        By signing up you agree to receive Lulu&rsquo;s news, new menus and offers by email. Unsubscribe any time.
      </p>
    </form>
  );
}
